

export const SET_SELECTED_LAB = "SET_SELECTED_LAB";

export const setSelectedLab = (selectedLab: any) => {
    return {
        type: SET_SELECTED_LAB,
        payload: selectedLab
    }
}